export default __webpack_public_path__ + "static/media/paycard-spei.08880400.png";